import { titleCase } from "title-case";
import { api_base } from "../core/api/api-base";
import { DataState } from "../core/hooks/useData";
import { ChatMessage, EntityType, Milestone, Name, PaymentMethod, account_form, account_resource, account_wf, account_wf_history, entity, entity_rel, event, form_def, job, ref, script, wf } from "../types";
import { report_def } from "../core/pdf/types";

export const api = {

    ...api_base,

	auth_login: async (props: {
		email: any,
		password: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/auth/login", props, dataState);
	},
	auth_impersonate: async (props: {
		user: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/auth/impersonate", props, dataState);
	},

	auth_logout: async (dataState?: DataState<any>) => {
		return api_base.post("/api/auth/logout", dataState);
	},
	
	auth_verify_token: async (dataState?: DataState<any>) => {
		return api_base.get("/api/auth/verify_token", dataState);
	},
	
	register_check: async (props: {
		email: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/register/check", props, dataState);
	},
	
	register_create: async (props: {
		email: any,
		name: any,
		password: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/register/create", props, dataState);
	},
	
	register_verify: async (props: {
		user: any,
		token: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/register/verify", props, dataState, { suppressNotification: true });
	},
	
	form_def_get: async (props: {
		ids?: string[],
		dependencies?: boolean,
	},
		dataState?: DataState<any>
	) => {
		return api_base.get<form_def | form_def[]>("/api/form_def", props, dataState);
	},
	
	form_def_post: async (props: {
		id?: string,
		title: string,
		deleted: number,
		data: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/form_def", props, dataState);
	},
	
	form_def_delete: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete("/api/form_def/:id", props, dataState);
	},

	report_def_get: async (props: {
		id: string,
		dependencies?: boolean,
	},
		dataState?: DataState<any>
	) => {
		return api_base.get<report_def[]>("/api/report_def", props, dataState);
	},
	report_def_get_all: async (dataState?: DataState<any>) => {
		return api_base.get<report_def[]>("/api/report_def/all", {
		}, dataState);
	},
	report_def_post: async (props: {
		id?: string,
		title: string,
		deleted: number,
		data: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/report_def", props, dataState);
	},
	report_def_delete: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete("/api/report_def/:id", props, dataState);
	},

	
	user_get: async (dataState?: DataState<any>) => {
		return api_base.get("/api/user", dataState);
	},
	user_defaults: async (dataState?: DataState<any>) => {
		return api_base.get("/api/user/defaults", dataState);
	},
	user_set_defaults: async (props: {
		package?: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/user/set_defaults", props, dataState);
	},
	
	user_post: async (props: {
		name: {
			given1: string,
			family: string,
		},
		mobile?: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/user", props, dataState);
	},

	user_accounts: async (dataState?: DataState<any>) => {
		return api_base.get("/api/user/accounts", dataState);
	},

	user_change_account: async (props: {
		toAccount: string
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/user/change-account", props, dataState);
	},

	user_search_all: async (props: {
		filter: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/user/search_all", props, dataState);
	},

	
	email_test: async (dataState?: DataState<any>) => {
		return api_base.post("/api/email_test", dataState);
	},


	account_invite: async (props: {
		email: string,
		name: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/account_invite", props, dataState);
	},
	account_invite_get: async (props: {
		token: string,
	}, dataState?: DataState<any>) => {
		return api_base.get("/api/account_invite", props, dataState);
	},
	account_invite_accept: async (props: {
		token: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/account_invite/accept", props, dataState);
	},
	account_invite_get_all: async (props: {
	}, dataState?: DataState<any>) => {
		return api_base.get("/api/account_invite/all", props, dataState);
	},

	account_invoice_reconcile: async (props: {
		awf: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/account_invoice/reconcile", props, dataState);
	},


	account_resource_get: async (props: {
		id?: string,
	}, dataState?: DataState<any>) => {
		return api_base.get<account_resource | account_resource[]>("/api/account_resource", props, dataState);
	},

	getDownloadUrl: function (blob: string) {
		let result = this.endpoint + `/api/account_resource/${blob}`;
		return result;
	},
	getDownloadSystemUrl: function (blob: string) {
		let result = this.endpoint + `/api/account_resource/system/${blob}`;
		return result;
	},
	getPaymentGatewayReturnUrl: function () {
		let result;

		if (this.endpoint.indexOf("localhost") >= 0) {
			result = "http://vpn.runningant.com:3005/api/payment/finalize_gateway_tx/";
		} else {
			result = this.endpoint + "/api/payment/finalize_gateway_tx/";
		}
		return result;
	},

	account_resource_upload: async (props: {
		name: string,
		data: any,
		associateWithAccountWorkflow?: string,
	}, dataState?: DataState<any>) => {

		const formData = new FormData();
		for(var m in props) {
			formData.append(m, (props as any)[m]);
		}

		return api_base.upload<any>("/api/account_resource/upload", formData, dataState);
	},

	account_wf_resource_del: async (props: {
		id: string,
		blob: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete(`/api/account_wf/:id/resource/doc/${props.blob}/`, props, dataState);
	},



	account_wf_history_get: async (props: {
		account_wf: string,
	}, dataState?: DataState<any>) => {
		return api_base.get<account_wf_history[]>("/api/account_wf_history", props, dataState);
	},

	account_wf_history_post: async (props: {
		account_wf: string,
		data: ChatMessage | Milestone,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/account_wf_history", props, dataState);
	},


	account_form_get: async (props: {
		id?: string,
	}, dataState?: DataState<any>) => {
		return api_base.get<account_form | account_form[]>("/api/account_form", props, dataState);
	},
	account_form_latest: async (props: {
	}, dataState?: DataState<any>) => {
		return api_base.get<account_form | account_form[]>("/api/account_form_latest", props, dataState);
	},
	
	account_form_with_def: async (props: {
		id: string,
		additional_refs?: string[],
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/account_form_with_def", props, dataState);
	},

	// account_form_post: async (props: {
	// 	def: string,
	// 	wf: string,
	// 	data: any,
	// 	title: string,
	// 	deleted: any,
	// }, dataState?: DataState<any>) => {
	// 	return api_base.post("/api/account_form", props, dataState);
	// },
	
	account_form_update: async (props: {
		id: any,
		title: any,
		data: any,
		generatedData?: any,
	}, dataState?: DataState<any>) => {
		return api_base.put("/api/account_form_update", props, dataState);
	},	

	account_form_delete: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete("/api/account_form/:id", props, dataState);
	},
	
	account_search: async (props: {
		qry: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/account/search", props, dataState);
	},	

	account_wf_start: async (props: {
		def: string,
		deleted: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/account_wf_start", props, dataState);
	},

	account_wf_active: async (props: {
		phase?: string,
		lastRefresh?: string,
	}, dataState?: DataState<any>) => {
		return api_base.post<{
			awfs: account_wf[],
			counts: {
				[k: string]: number,
			},
			lastRefresh: string,
		}>("/api/account_wf/active", props, dataState, {
			suppressNotification: true,
		});
	},

	account_wf_asic_data: async (props: {
		awf: string,
	}, dataState?: DataState<any>) => {
		return api_base.get<any>("/api/account_wf/asic_data", props, dataState);
	},
	
	account_wf_details: async (props: {
		awf: string,
	}, dataState?: DataState<any>) => {
		return api_base.get<any>("/api/account_wf/details", props, dataState);
	},

	account_wf_transition: async (props: {
		id: string,
		toState: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/account_wf/transition", props, dataState);
	},

	account_wf_update: async (props: {
		id: any,
		title: any,
	}, dataState?: DataState<any>) => {
		return api_base.put<account_wf>("/api/account_wf_update", props, dataState);
	},	

	account_wf_delete: async (props: {
		id: any,
	}, dataState?: DataState<any>) => {
		return api_base.delete<account_wf>("/api/account_wf/:id", props, dataState);
	},	

	geo_search: async (props: {
		qry: string,
	}, dataState?: DataState<any>) => {
		return new Promise((resolve, reject) => {
			api_base.post<any[]>("/api/geo/search", props, dataState).then((response) => {
				// convert values to title case
				for(let r of response) {
					if (r.street) r.street = titleCase(r.street.toLowerCase());
					if (r.locality) r.locality = titleCase(r.locality.toLowerCase());
				}
				resolve(response);

			}).catch((e) => {
				reject(e);
			});
		});
	},

	ref_get: async (props: {
		ids?: string[],
		dependencies?: boolean,
	},
		dataState?: DataState<any>
	) => {
		return api_base.get<ref[]>("/api/ref", props, dataState);
	},

	ref_post: async (props: {
		id: string,
		title: string, 
		data: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/ref", props, dataState);
	},

	ref_delete: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete("/api/ref/"+encodeURIComponent(props.id), props, dataState);
	},


	script_get: async (props: {
		ids?: string[],
		dependencies?: boolean,
	},
		dataState?: DataState<any>
	) => {
		return api_base.get<script[]>("/api/script", props, dataState);
	},

	script_post: async (props: {
		id: string,
		title: string, 
		script: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/script", props, dataState);
	},

	script_delete: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete("/api/script/"+encodeURIComponent(props.id), props, dataState);
	},



	sync_to_prod: async (props: {
		container: string,
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/sync_to_prod/", props, dataState);
	},
	sync_from_prod: async (props: {
		container: string,
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/sync_from_prod/", props, dataState);
	},

	wf_get: async (props: {
		ids?: string[],
		dependencies?: boolean,
	},
		dataState?: DataState<any>
	) => {
		return api_base.get<wf | wf[]>("/api/wf", props, dataState);
	},
	
	wf_post: async (props: {
		id?: string,
		title: string,
		deleted: number,
		data: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/wf", props, dataState);
	},
	
	wf_delete: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete("/api/wf/:id", props, dataState);
	},


	entity_get: async (props: {
		id?: string,
	}, dataState?: DataState<any>) => {
		return api_base.get<entity | entity[]>("/api/entity", props, dataState);
	},

	entity_get_specific: async (props: {
		ids: string[],
	}, dataState?: DataState<any>) => {
		return api_base.post<entity | entity[]>("/api/entity/specific", props, dataState, { suppressNotification: true });
	},

	entity_relationships: async (props: {
		entity: string,
	}, dataState?: DataState<any>) => {
		return api_base.post<entity_rel[]>("/api/entity/relationships", props, dataState, { suppressNotification: true });
	},

	entity_search: async (props: {
		types: EntityType[],
		qry?: string,
	}, dataState?: DataState<any>) => {
		return api_base.post<entity[]>("/api/entity/search", props, dataState);
	},
	

	entity_create: async (props: {
		title: string,
		data: any,
		deleted: any,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/entity", props, dataState);
	},
	
	entity_update: async (props: {
		id: any,
		title: any,
		data: any,
	}, dataState?: DataState<any>) => {
		return api_base.put("/api/entity", props, dataState);
	},	

	entity_delete: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete("/api/entity/:id", props, dataState);
	},

	entity_update_from_form: async (props: {
		type: string,
		form: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/entity/update_from_form", props, dataState);
	},		

	event_get: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.get<event | event[]>("/api/event", props, dataState);
	},

	payment_method: async (dataState?: DataState<any>) => {
		return api_base.get<PaymentMethod>("/api/payment/method", undefined, dataState);
	},

	payment_access_code_create: async (props: {
		purpose: "create_token_customer" | "update_token_customer",
		redirectUrl: string,
		paymentMethod: {
			givenName1: string,
			familyName: string,
			country: string,
		},
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/payment/access_code_create", props, dataState);
	},

	payment_finalize_gateway_tx: async (props: {
		AccessCode: any,
	}, dataState?: DataState<any>) => {
		return api_base.get("/api/payment/finalize_gateway_tx", props, dataState);
	},
	
	payment_invoice: async (props: {
		invoice: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/payment/invoice", props, dataState);
	},

	payment_awf: async (props: {
		awf: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/payment/awf", props, dataState);
	},

	payment_defer_awf: async (props: {
		awf: string,
		paymentType: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/payment_defer/awf", props, dataState);
	},

	version: async (props: {
	}, dataState?: DataState<any>) => {
		return api_base.get("/api/version", props, dataState);
	},

	status_delete: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete("/api/status/:id", props, dataState);
	},



	// techsync
	job_get: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.get<job[]>("/api/job", props, dataState);
	},
	job_get_all: async (props: {
	}, dataState?: DataState<any>) => {
		return api_base.get<job[]>("/api/job/all", props, dataState);
	},
	job_post: async (props: {
		id?: string,
		num: string,
		name: Name,
		deleted: boolean,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/job", props, dataState);
	},
	job_send_sms: async (props: {
		job: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/job/send_sms", props, dataState);
	},
	job_delete: async (props: {
		id: string,
	}, dataState?: DataState<any>) => {
		return api_base.delete("/api/job/:id", props, dataState);
	},
	job_link_video: async (props: {
		job: string,
		video: string,
		size: number,
		duration: number,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/job/link_video", props, dataState);
	},
	job_complete: async (props: {
		job: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/job/complete", props, dataState);
	},
	job_approve_quote: async (props: {
		job: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/job/approve_quote", props, dataState);
	},

	job_delete_video: async (props: {
		job: string,
		blob: string,
	}, dataState?: DataState<any>) => {
		return api_base.post("/api/job/delete_video", props, dataState);
	},

	job_get_sas_token: async (props: {
		blob?: string,
	}, dataState?: DataState<any>) => {
		return api_base.get("/api/job/get_sas_token", props, dataState);
	},


};


